import React from 'react'
import PropTypes from 'prop-types';
import PrimaryTenderChoice from "./PrimaryTenderChoice";

function Index(
    {
        expanded,
    }) {

    return (expanded && <PrimaryTenderChoice />)
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;